import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { AppActions } from '@actions/index'
import { HttpApiService } from '@services/http-api.service';
import { EMPTY } from 'rxjs';
import Swal, { SweetAlertIcon } from 'sweetalert2';

/**
 * AppEffects handles all side effects the app and
 * dispatches the correspondent actions and servides.
 */
@Injectable()
export class AppEffects {
  /**
     * Pipes all [App] Logger Request
     * actions and peroforms a HTTP petition to log
     * the request to the data base. When the petition
     * is succesfull it dispatches the [App] Logger
     * Request Success action. If the petition returns 
     * an error the effect dispatches [App] App Error
     * to store the error on app state.
  */
  saveLogger$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.loggerRequest),
      switchMap(({ request }) =>
        this.httpApiService
          .postRequest(request)
          .pipe(
            map(response => AppActions.loggerRequestSuccess({ response })),
            catchError(_ => EMPTY)
          )
      )
    )
  );

  saveCognitoErrors$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.saveCognitoError),
      switchMap(({ request }) =>
        this.httpApiService
          .postRequest(request)
          .pipe(
            map(response => AppActions.saveCognitoErrorSuccess({ response })),
            catchError(_ => EMPTY)
          )
      )
    )
  );
      
  submitDataDeletionRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AppActions.submitDataDeletionRequest),
      switchMap(({ request }) =>
        this.httpApiService
          .postRequest(request)
          .pipe(
            tap(_ => this.launchAlertMssg("Your request was successfully submitted", "We'll contact you once this is done!", "success")),
            catchError(_ => {
              this.launchAlertMssg('There was an error submitting your request', 'Please try again or contact your administrator.', 'error')
              return EMPTY;
            })
          )
      )
    ),
    { dispatch: false }
  );

  private launchAlertMssg(title: string, message: string, type: SweetAlertIcon) {
    Swal.fire({
      title: title,
      html: message,
      icon: type,
      showCancelButton: false,
      confirmButtonText: 'OK'
    })
  }

  /**
   * AppEffects Constructor
   * @param actions$ 
   * @param httpApiService The HTTP service to build HTTP requests
   */
  constructor(
    private actions$: Actions,
    private httpApiService: HttpApiService
  ) { }

}
